import { useQuery } from '@apollo/client';
import { GET_TEAM_LANDING_USERS } from '../graphql/queries';

const useGetStaffLandingUsers = () => {
  const { data: teamLandingUsers } = useQuery(GET_TEAM_LANDING_USERS);
  return teamLandingUsers?.teamLandingUsers || [];
};

export default useGetStaffLandingUsers;
